import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace QmsAuditTypesFields {
  export enum CommonField {
    AuditTypesSequentialNumberingFormat = 'AuditTypes.SequentialNumberingFormat',
  }
}

class CommonConfig extends SettingsSubModule {
  @SettingsSubModule.value(QmsAuditTypesFields.CommonField.AuditTypesSequentialNumberingFormat, '')
  sequentialNumberingFormat: SettingValue<string>;
}

export class QmsAuditTypesModule extends SettingsModule {
  @SettingsModule.value(CommonConfig) common: CommonConfig;
}
